import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import isEmpty from 'lodash/isEmpty';
import Slide from '@material-ui/core/Slide';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Close from 'react-icons/lib/io/close';
import {FormattedMessage, injectIntl} from 'react-intl';
import DialogWrapper from '../../../../components/dialog/Dialog';
import BankContainer from './BankContainer';
import UploadsContainer from './UploadsContainer';
import BaseButton from '../../../../components/button/BaseButton';
import {customEvent} from '../../../../utils/analyticsUtil';
import {actions, category, DialogTypes, events} from '../../../../constants/enums';

const tabClasses = {root: 'tab-button', label: 'tab-label', selected: 'tab-selected'};

@injectIntl
@inject('searchStore', 'dialogStore', 'trackStore', 'looperStore')
@observer
class StudioLibrary extends Component {
    @observable activeTabIndex = this.props.activeTab || 0;

    componentWillUnmount() {
        this.closeDialog();
    }

    @action componentWillUpdate(nextProps) {
        if ('activeTab' in nextProps && this.activeTabIndex !== nextProps.activeTab) {
            this.activeTabIndex = nextProps.activeTab;
        }
    }

    @action setActiveTabIndex = (event, newValue) => {
        this.activeTabIndex = newValue;
        if (this.props.changeActiveTab) {
            this.props.changeActiveTab(newValue);
        }
    };

    handlePlayPause = track => async () => {
        if (!track.duration) return;
        const {trackStore} = this.props;
        customEvent(events.CustomEvent, {category: category.Studio, action: actions.Play});
        trackStore.stopAllTracks(track);
        trackStore.togglesSubscribePlayPause(track, null, track.startTime, track.endTime, false, true);
    };

    handleAddTrack = track => async () => {
        const {looperStore, trackStore} = this.props;
        customEvent(events.CustomEvent, {category: category.LooperSection, action: actions.AddStem, label: 'click'});
        await looperStore.addToLooper(track);
        trackStore.resetTrack(track);
    };

    handleRemoveTrack = track => () => {
        customEvent(events.CustomEvent, {category: category.LooperSection, action: actions.Remove});
        this.props.looperStore.removeFromLooper(track);
    };

    checkTrackInLooper = id => (
        this.props.looperStore.looperTracks.some(t => t.id === id)
    );

    closeDialog = () => {
        this.props.dialogStore.closeDialog(DialogTypes.StudioLibrary);
    }

    render() {
        const {dialogStore, trackStore, intl: {formatMessage: translate}} = this.props;
        const isDisabled = (this.activeTabIndex === 0 && isEmpty(trackStore.tracks)) || (this.activeTabIndex === 1 && isEmpty(trackStore.uploadedTracks));
        return (
            <DialogWrapper
                BackdropProps={{classes: {root: 'overlay'}}}
                TransitionComponent={Slide}
                TransitionProps={{direction: 'up'}}
                classes={{root: 'm-library-modal-root', paper: 'paper'}}
                open={dialogStore.getDialogState(DialogTypes.StudioLibrary)}
                onBackdropClick={this.closeDialog}
            >
                <div id="library-modal" className="m-library-modal-content">
                    <button className="m-library-modal-close" onClick={this.closeDialog}>
                        <Close />
                    </button>
                    <div className="modal-page-name"><FormattedMessage id="studio.addLoops" /></div>
                    <h3><FormattedMessage id="studio.library.heading" /></h3>
                    <Tabs
                        classes={{root: 'page-mobile-tabs', indicator: 'indicator'}}
                        variant="fullWidth"
                        value={this.activeTabIndex}
                        onChange={this.setActiveTabIndex}>
                        <Tab
                            classes={tabClasses}
                            label={<FormattedMessage id="library.tabs.sampleBank"/>}/>
                        <Tab
                            classes={tabClasses}
                            label={<FormattedMessage id="library.tabs.uploads"/>}/>
                    </Tabs>
                    <div className="m-library-body">
                        <div className="m-library-body-wrapper">
                            {dialogStore.getDialogState(DialogTypes.StudioLibrary) && this.activeTabIndex === 0 &&
                                <BankContainer
                                    isTrackAdded={this.checkTrackInLooper}
                                    playTrack={this.handlePlayPause}
                                    addTrack={this.handleAddTrack}
                                    removeTrack={this.handleRemoveTrack}
                                />
                            }
                            {dialogStore.getDialogState(DialogTypes.StudioLibrary) && this.activeTabIndex === 1 &&
                                <UploadsContainer
                                    isTrackAdded={this.checkTrackInLooper}
                                    playTrack={this.handlePlayPause}
                                    addTrack={this.handleAddTrack}
                                    removeTrack={this.handleRemoveTrack}
                                />
                            }
                        </div>
                        <div className="m-library-sticky">
                            <BaseButton
                                disabled={isDisabled}
                                className="m-library-done"
                                label={translate({id: 'general.done'})}
                                onClick={this.closeDialog}
                            />
                        </div>
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default StudioLibrary;
